import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.clickOutsideHandler = this.clickOutside.bind(this)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")

    if (!this.menuTarget.classList.contains("hidden")) {
      document.addEventListener("click", this.clickOutsideHandler)
    } else {
      document.removeEventListener("click", this.clickOutsideHandler)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.clickOutsideHandler)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }
}
